<template>
    <div class="nav-menu">
        <ElPopover
            v-for="item in menuData"
            :key="`${currentRoute}-${item.path}`"
            :visibleArrow="false"
            :disabled="!item.children || !item.children.length"
            :openDelay="150"
            placement="right"
            trigger="hover"
            popperClass="nav-menu__popover"
        >
            <div slot="reference" class="nav-menu__container">
                <router-link
                    :key="item.path"
                    tag="a"
                    :to="{ path: item.path, query: $route.query }"
                    :class="['nav-menu__item', `pendo-track__nav-menu__${item.name}`, {
                        'router-link-active': $route.path.split('/')[1] === item.path.split('/')[1],
                        'nav-menu__item--no-data': !item.hasData,
                        'nav-menu__item--has-icon': item.children && item.children.length
                    }]"
                >
                    <slot :context="item">
                        {{ item.label }}
                    </slot>
                </router-link>
                <slot name="append" :context="item" />
                <PtIcon v-if="item.children && item.children.length" icon="SolidArrowRight" class="nav-menu__icon" />
            </div>
            <!--二级路由-->
            <div v-if="item.children && item.children.length" v-addIframe class="nav-menu--in-popover">
                <div v-for="subItem in item.children" :key="subItem.name" class="nav-menu--in-popover__container">
                    <router-link
                        :key="subItem.path"
                        tag="a"
                        :to="{ path: subItem.path, query: $route.query }"
                        :class="['nav-menu--in-popover__item', `pendo-track__nav-menu__${subItem.name}`, {
                            'router-link-active': $route.path === subItem.path,
                            'nav-menu--in-popover__item--no-data': !subItem.hasData
                        }]"
                        @mouseup.native.stop
                    >
                        {{ subItem.label }}
                    </router-link>
                </div>
            </div>
        </ElPopover>
    </div>
</template>

<script>
import { Popover } from 'element-ui';
import { Icon } from 'patsnap-biz';
import _ from 'lodash';
import { ROUTE_NAME_SUBDUAL } from '@/constants';
import addIframe from '../directives/addIframe';
import '@patsnap-ui/icon/assets/solid/ArrowRight.svg';

export default {
    name: 'NavMenu',
    components: {
        ElPopover: Popover,
        PtIcon: Icon,
    },
    directives: {
        addIframe,
    },
    props: {
        patentId: {
            type: String,
            required: true,
        },
        menuData: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    computed: {
        // 为了路由跳转后关闭二级导航
        currentRoute() {
            return _.get(this.$route, 'path', 'default');
        },
    },
    created() {
        this.ROUTE_NAME_SUBDUAL = ROUTE_NAME_SUBDUAL;
    },
};
</script>

<style lang="scss">
    /*一级导航*/
    .nav-menu {
        .nav-menu__container {
            position: relative;
            margin-bottom: 4px;
        }
        .nav-menu__item {
            user-select: none;
            display: block;
            border-radius: 4px;
            color: $neutral-blue-1000;
            padding: 4px 8px;
            text-align: left;
            line-height: 24px;
            cursor: pointer;
            overflow: hidden;
            letter-spacing: 0.25px;
            &:hover {
                background-color: $neutral-blue-40;
            }
            &.router-link-active {
                background-color: $neutral-blue-400;
                color: #fff;
            }
            &--no-data{
                color: $neutral-blue-60;
            }
            &--has-icon {
                padding-right: 24px;
            }
        }
        .nav-menu__icon {
            position: absolute;
            top: 50%;
            right: 4px;
            transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            font-size: 20px !important;
            fill: $text-disable !important;
        }
    }
    /*二级导航 由于hotkey功能不能使用一级的class*/
    .nav-menu__popover {
        padding: 8px !important;
    }
    .nav-menu--in-popover {
        .nav-menu--in-popover__container {
            margin-bottom: 4px;
            &:last-of-type {
                margin-bottom: 0;
            }
        }
        .nav-menu--in-popover__item {
            user-select: none;
            display: block;
            border-radius: 4px;
            color: $neutral-blue-1000;
            padding: 4px 8px;
            text-align: left;
            line-height: 24px;
            cursor: pointer;
            overflow: hidden;
            letter-spacing: 0.25px;
            &:hover {
                background-color: $neutral-blue-20;
            }
            &.router-link-active {
                background-color: $neutral-blue-400;
                color: #fff;
            }
            &--no-data{
                color: $neutral-blue-60;
            }
        }
    }
    .nav-menu--in-popover .nav-menu__item:hover {
        background-color: $neutral-blue-20;
    }
</style>
